module.exports = __webpack_public_path__ + "img/adds.b9c24aa5.png";